export const roleService = {
    methods: {
        hasRole(roles) {
            if (this.$keycloak.authenticated) {
                return this.$keycloak.hasResourceRole(roles)
            } else {
                return false;
            }
        },

        hasAnyRole() {
            if (this.$keycloak) {
                // console.log(this.$keycloak.hasAnyRole)
                return this.$keycloak.authenticated && (this.$keycloak.hasAnyRole || this.userRole.hasAnyRole)
            } else {
                return false;
            }
        },
        displayRole() {
          if (this.$keycloak) {
            // console.log(this.$keycloak.hasAnyRole)
            return this.$keycloak.role
          } else {
            return "";
          }
        }
    }
}
